// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"24":"f77b74cd","171":"a801f3dc","245":"bc8d1236","254":"4c2b80e2","468":"84d66982","486":"70937f42","614":"f388f3b5","648":"35a7f41a","698":"f24c6073","740":"d7a6e2d5","817":"5a5189f1"}[chunkId] + ".chunk.js";
};